import { del } from '../request';
import type { Benefit } from '../../@types/benefits';
import { APP_CONFIG } from '../../config';
import { benefitViewedStatusToApi } from './converter/benefitViewedStatus';
import { saveUserInteraction } from '../userInteractions/userInteractions';

export const resetBenefitsViewedStatus = async (): Promise<void> => {
  await del(`${APP_CONFIG.apiEndpoint}/user-interactions/my`);
};

export const saveBenefitViewedStatus = async (benefit: Benefit): Promise<void> => {
  const body = benefitViewedStatusToApi(benefit);
  await saveUserInteraction(body);
};
